module.exports = __webpack_public_path__ + "media/images/solar-installer-bg-3c91eacf163c265b81e00999e8f437f9.jpg";